import _shuffle from 'lodash/shuffle';
import _filter from 'lodash/filter';
import _uniqBy from 'lodash/uniqBy';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $scope, $timeout, $stateParams, $document, $location, $q, metaTagService, utilsService,
  jsSdkUser, tlEE, jsSdkCuratedList, jsSdkCuratedListFollow, jsSdkCity, imgix, loggerService, tracking, modalService) {
  $scope.loading = true;
  $scope.saving = false;
  $scope.curatedList = null;
  $scope.curatedList = null;
  $scope.items = [];
  $scope.followedLists = [];
  $scope.currentVenueFilter = null;

  _loadCuratedList($stateParams.id, function() {
    _loadCity($scope.curatedList.city);
  });

  _loadFollowedCuratedLists();

  tlEE.on(jsSdkUser.EVENTS.USER_UPDATED, function() {
    _loadFollowedCuratedLists();
  });

  $scope.imgix = function(src) {
    const options = {
      width: 1200,
      height: 700
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.isFollowing = function() {
    const user = jsSdkUser.getCurrentUser();

    let isFollowing = false;

    if (user && $scope.curatedList && $scope.curatedList.follow && $scope.curatedList.follow[0]) {
      isFollowing = $scope.curatedList.follow[0].user === user.id;
    }

    return isFollowing;
  };

  $scope.toggleFollow = function(list) {
    if (!list || !list.id) return;

    const user = jsSdkUser.getCurrentUser();

    $scope.saving = true;

    // If user is already following
    if (user && $scope.isFollowing()) {
      _unfollow(list);
      return;
    }

    const options = {
      startState: 'existingUser'
    };

    modalService.authUser(function success() {
      _follow(list);
    }, function error() {
      $scope.saving = false;
    }, options);
  };

  $scope.toggleCurrentVenue = function(venue) {
    if ($scope.currentVenueFilter && $scope.currentVenueFilter.id === venue.id) {
      $scope.currentVenueFilter = null;
    } else {
      $scope.currentVenueFilter = venue;
    }
  };

  $scope.filterByCurrentVenue = function(item) {
    if (!$scope.currentVenueFilter) {
      return true;
    } else if ($scope.currentVenueFilter.id === item.venue.id) {
      return true;
    }

    return false;
  };

  function _follow(list) {
    jsSdkCuratedListFollow.createByCuratedListId(list.id)
      .then(function() {
        tracking.trackEvent(SEGMENT_EVENTS.FollowedCuratedList, {
          id: list.id,
          title: list.title
        });

        _loadCuratedList(list.id);
      }, _error);
  }

  function _unfollow(list) {
    jsSdkCuratedListFollow.removeByCuratedListId(list.id)
      .then(function() {
        tracking.trackEvent(SEGMENT_EVENTS.UnfollowedCuratedList, {
          id: list.id,
          title: list.title
        });

        _loadCuratedList(list.id);
      }, _error);
  }

  function _error(resp) {
    $scope.loading = false;
    $scope.saving = false;
    loggerService.error(resp);
  }

  function _loadFollowedCuratedLists() {
    const user = jsSdkUser.getCurrentUser();

    if (!user) {
      return;
    }

    $scope.followedLists = [];

    const options = {
      fields: 'curatedList()'
    };

    jsSdkCuratedListFollow.listByUserId(user.id, options)
      .then(function(resp) {
        $scope.followedLists = _shuffle(resp);
      });
  }

  function _loadCity(id) {
    jsSdkCity.readById(id).then(function(resp) {
      $scope.city = resp;
    });
  }

  function _loadCuratedList(id, next) {
    const options = {
      items: true,
      follow: true,
      fields: [
        'venue(id, name)',
        'event(id, name, date, images, primaryImage, dateStart, dateEnd)'
      ].join(',')
    };

    jsSdkCuratedList.readById(id, options)
      .then(function(resp) {
        $scope.curatedList = resp;
        $scope.items = resp.items;

        const eventItems = _filter($scope.items, {
          type: 'EVENT'
        });

        $scope.venues = _uniqBy(eventItems.map(item => item.venue), venue => venue.id);

        metaTagService.set({
          title: resp.title,
          description: resp.description,
          facebookImage: resp.imageUrl
        });

        $scope.shareBarConfig = {
          url: utilsService.createUrl(`/list/${$scope.curatedList.id}`),
          message: `See Tablelist's - ${$scope.curatedList.title}`
        };

        const url = utilsService.createUrl(`/list/${$scope.curatedList.id}`);
        const msg = `See Tablelist's - ${$scope.curatedList.title}`;

        $scope.facebookLink = utilsService.facebookLink(url);
        $scope.twitterLink = utilsService.twitterLink(url, msg);
        $scope.emailLink = utilsService.mailtoLink(url, msg);

        if (next) next();

        $scope.loading = false;
        $scope.saving = false;

      }, function() {

        $scope.loading = false;
        $scope.saving = false;

        utilsService.link(`/404?target=${$location.$$absUrl}`);
      });
  }
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$timeout',
  '$stateParams',
  '$document',
  '$location',
  '$q',
  'metaTagService',
  'utilsService',
  'jsSdk.user',
  'tl.ee',
  'jsSdk.curatedList',
  'jsSdk.curatedListFollow',
  'jsSdk.city',
  'jsSdk.imgix',
  'loggerService',
  'trackingService',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/curatedList/curatedListCtrl.js